'use client';

import { useState } from 'react';

import { Icon, IconName, IconSize } from '@bytel/trilogy-react';

import { PromoConfigurator } from '@components/promo-configurator';
import { PromoHomeModal } from '@components/promo-home-modal';

import { SwitchChangeEvent } from '@trilogy-ds/react/lib/components/switch/SwitchProps';

type OfferConfiguratorProps = {
    onChangePromos: (clientBbox?: boolean) => void;
    isClientBbox: boolean;
    isLoading: boolean;
};

export function OfferConfigurator({ onChangePromos, isClientBbox, isLoading }: Readonly<OfferConfiguratorProps>) {
    const [isHomeModalOpen, setIsHomeModalOpen] = useState(false);

    return (
        <>
            <PromoConfigurator
                title='Voir les prix avec une box internet'
                description='Si vous avez ou prenez une Bbox.'
                onChange={(isClientBbox: SwitchChangeEvent) => onChangePromos(isClientBbox.switchState)}
                isChecked={isClientBbox}
                disabled={isLoading}
                isFullwidth
            >
                <Icon
                    name={IconName.INFOS_CIRCLE}
                    size={IconSize.SMALL}
                    onClick={() => setIsHomeModalOpen(true)}
                    className='cursor-pointer'
                />
            </PromoConfigurator>
            <PromoHomeModal isOpen={isHomeModalOpen} onClose={() => setIsHomeModalOpen(false)} />
        </>
    );
}
